module.exports = __webpack_public_path__ + "img/photo-06.3796a74a.jpg";